import React from 'react';
import PropTypes from 'prop-types';

import { DOMAIN_DEFAULT } from '@blocks/constants';
import useOnScreen from '@blocks/hooks/useOnScreen';

const PriceSelect = React.lazy(() => import('./price-select'));

const PriceSelectWidget = ({
  domain = DOMAIN_DEFAULT,
  hideExpiredAmount = false,
  sortType = 'deadline-asc',
}) => {
  const ref = React.useRef(null);
  const isOnscreen = useOnScreen(ref, {
    once: true,
  });

  return (
    <div ref={ref}>
      {isOnscreen && (
        <React.Suspense fallback={null}>
          <PriceSelect
            domain={domain}
            hideExpiredAmount={hideExpiredAmount}
            sortType={sortType}
          />
        </React.Suspense>
      )}
    </div>
  );
};

PriceSelectWidget.propTypes = {
  domain: PropTypes.string,
  hideExpiredAmount: PropTypes.bool,
  sortType: PropTypes.oneOf(['price-asc', 'price-desc', 'deadline-asc', 'deadline-desc']),
};

export default PriceSelectWidget;
